export const getPreloaded = (state) => state.preloader.preloaded
